import { Helmet } from 'react-helmet-async';

interface MetaTagsProps {
  title: string;
  imageUrl?: string;
  description?: string;
}

function MetaTags({
  title,
  description,
  imageUrl = `${window.location.protocol}//${window.location.hostname}/default-meta-image.png`,
}: MetaTagsProps) {
  const prefixedTitle = `eklipX | ${title}`;

  return (
    <Helmet>
      <meta name='title' content={prefixedTitle} />
      <meta name='description' content={description} />
      <meta property='og:title' content={prefixedTitle} />
      <meta property='og:description' content={description} />
      <meta property='og:image' content={imageUrl} />
      <meta property='og:url' content={window.location.href} />
      <meta property='og:site_name' content='eklipX' />
      <meta name='twitter:card' content='summary_large_image' />
      <meta name='twitter:title' content={prefixedTitle} />
      <meta name='twitter:description' content={description} />
      <meta name='twitter:image' content={imageUrl} />
      <meta name='twitter:url' content={window.location.href} />
    </Helmet>
  );
}

export default MetaTags;
